module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/chicken-btn-audio-english.b7d0a408.png";